var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.$route.meta.header)?_c('Header',{attrs:{"id":"header"}}):_vm._e(),(_vm.isRouterAlive)?_c('Content',{attrs:{"id":"content"}}):_vm._e(),(_vm.$route.meta.footer)?_c('Footer'):_vm._e(),_c('Backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }